import React from 'react'
import './index.scss'
import { i18n } from '../../common/util'
import { AppContext } from '../../config/context'

class BlackList extends React.Component {
    constructor() {
        super(...arguments)
    }

    render() {
        const lang = this.context.user.lang
        return <div className="black-list-modal">
            <div className="black-list-wrapper">
                <div className="black-list-header">提示<i className="close" onClick={this.props.close}></i></div>
                <div className="black-list-content">{i18n(this.props.content, lang)}</div>
                <div className="black-list-footer">
                    <button className="black-list-btn" onClick={this.props.close}>我知道了</button>
                </div>
            </div>
        </div>
    }
}

BlackList.contextType = AppContext
export default BlackList